<template>
    <div class="review-info">
        <!-- Selfpay Flow -->
        <template v-if="this.$store.getters.isPrepayment">
            <div class="review-info__header">
                Your cost today
            </div>
            <div class="review-info__cost">
                ${{ this.$store.getters.amount }}
            </div>
            <p>
                Your at-home collection kit will ship via FedEx once your payment is confirmed.
            </p>
            <div class="review-info__hsa">
                <img src="@/assets/credit-card-blue.png" alt="Card" class="card-icon">
                <div class="review-info__hsa-info">
                    FSA and HSA cards are accepted
                </div>
            </div> 
            <p>
                Pay with your FSA or HSA card, or submit for reimbursement after payment.        
            </p>
            <button class="cta-button" @click="handleContinue">
                Continue to payment
            </button>
        </template>

        <!-- Insurance Flow -->
        <template v-else>
            <div class="review-info__cost review-info__cost--small">
                Today, you pay nothing
            </div>
            <p style="margin-bottom: 24px">
                We'll work with your insurance to determine what you owe. If your out-of-pocket cost exceeds ${{ this.$store.getters.amount }}, we'll reach out before processing your test. You'll have the option to pay the self-pay rate of ${{ this.$store.getters.amount }} instead.
            </p>
            <p>
                To get your kit on its way, we'll ask you to securely save a payment method for any balance owed after your insurance processes.
            </p>
            <button class="cta-button" @click="handleContinue">
                Add payment method
            </button>
        </template>
    </div>
</template>

<script>
export default {
    name: "ReviewCostInfo",
    methods: {
        handleContinue() {
            this.$store.dispatch("setPufIsCostReviewed", true);
            this.$router.push({ name: "Payment" });
        }
    }
};
</script>

<style lang="scss" scoped>
.review-info {
    margin: 32px 0;
    padding: 24px 56px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid var(--Color-gray-300, #CDD5DF);

    .review-info__header {
        color: var(--Color-gray-600, #4B5565);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hm, 24px);
        font-style: normal;
        font-weight: 700;
        line-height: 133%; /* 31.92px */
        letter-spacing: -0.48px;
    }

    .review-info__cost {
        color: var(--Color-blue-bright-500, #0691EF);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-dl, 72px);
        font-style: normal;
        font-weight: 600;
        line-height: 125%; /* 90px */
        letter-spacing: -1.44px;

        &.review-info__cost--small {
            font-size: var(--font-size-h2xl, 40px);
            line-height: 120%; /* 48px */
            letter-spacing: -0.8px;
            margin-bottom: 16px;
        }
    }

    .review-info__hsa {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--Color-blue-bright-500, #0691EF);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-tl, 18px);
        font-style: normal;
        font-weight: 600;
        line-height: 156%; /* 28.08px */
        letter-spacing: -0.18px;
        margin-top: 24px;
        margin-bottom: 4px;

        img {
            width: 27px;
            margin-right: 12px;
        }
    }

    p {
        color: var(--gray-800, var(--Color-gray-800, #202939));
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-tl, 18px);
        font-style: normal;
        font-weight: 400;
        line-height: 156%; /* 28.08px */
        letter-spacing: -0.18px;
        max-width: 870px;
        margin-left: auto;
        margin-right: auto;
    }

    .cta-button {
        font-family: "Inter", "Lato", sans-serif;
        align-self: flex-start;
        padding: 14px 28px;
        font-size: 1.25em;
        color: #ffffff;
        background-color: #0092E1;
        border: none;
        border-radius: 54px;
        cursor: pointer;
        transition: background-color 0.2s ease;
        margin-top: 24px;

        &:hover {
            background-color: #0052a3;
        }
    }
}

@include sm() {
    .review-info {
        padding: 24px 10px;
        
        .review-info__header {
            font-size: 16px;
            margin-bottom: 8px;
        }

        .review-info__cost {
            font-size: 32px;
            margin-bottom: 8px;

            &.review-info__cost--small {
                font-size: 32px;
            }
        }

        .review-info__hsa {
            font-size: 16px;

            img {
                display: none;
            }
        }

        p {
            font-size: 16px;
        }

        .cta-button {
            font-size: 18px;
        }
    }
}

@media (max-width: 400px) {
    .review-info {

        .review-info__cost {

            &.review-info__cost--small {
                font-size: 24px;
            }
        }
    }
}
</style>
